import moment from "@/utils/moment";

const HOLIDAYS = [
  {
    name: "Véspera de Natal",
    day: "24/12/2024",
    activePurchase: true
  },
  {
    name: "Natal",
    day: "25/12/2026",
    activePurchase: false
  },
  {
    name: "Véspera de Ano Novo",
    day: "31/12/2024",
    activePurchase: true
  },
  {
    name: "Ano Novo",
    day: "01/01/2026",
    activePurchase: false
  }
];

const CUSTOM_DISABLED_DATES = [];

const daysWithDisabledPurchase = (city = null) => {
  return [...HOLIDAYS, ...CUSTOM_DISABLED_DATES]
    .filter(
      day =>
        !day.activePurchase ||
        (city && day.citiesBlock && day.citiesBlock.includes(city))
    )
    .map(({ day }) => day);
};

const holidays = () => {
  return HOLIDAYS.map(day => {
    return {
      ...day,
      day: moment(day.day, "DD/MM/YYYY")
    };
  });
};

const isPurchaseDisabled = desiredDate => {
  return holidays().some(({ day, activePurchase }) => {
    return day.isSame(desiredDate, "day") && !activePurchase;
  });
};

const isHoliday = desiredDate => {
  return holidays().some(({ day }) => {
    return day.isSame(moment(desiredDate), "day");
  });
};

const isBusinessDay = desiredDate => {
  return moment(desiredDate).isBusinessDay();
};

const holiday = desiredDate => {
  return holidays().find(({ day }) => {
    return day.isSame(moment(desiredDate), "day");
  });
};

export default {
  daysWithDisabledPurchase,
  holidays,
  isPurchaseDisabled,
  isHoliday,
  isBusinessDay,
  holiday
};



// WEBPACK FOOTER //
// ./src/utils/helpers/specialDatesHelper.js